import React, { useEffect, useState } from 'react';
import { LYNKED_WHITE } from '../../../../consts/colors';
import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LANG_DISPLAY_KEY } from '../../../../consts/language';
import { useStyles } from './styles';
import { ILanguage } from '../../../../interfaces/index.types';
import i18n from 'i18next';

const data: ILanguage = {
  en: {
    KEY_VALUE: 'English',
  },
  ja: {
    KEY_VALUE: 'Japan',
  },
};

export default function LanguageDropdown({ paperClass }: { paperClass: string }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState('ja');

  useEffect(() => {
    const lang = localStorage.getItem(LANG_DISPLAY_KEY);
    if (!lang) localStorage.setItem(LANG_DISPLAY_KEY, 'ja');
    setLanguage(lang || 'ja');
  }, []);

  const handleChangeOption = (event: SelectChangeEvent) => {
    const lang = event.target.value;
    localStorage.setItem(LANG_DISPLAY_KEY, lang);
    setLanguage(lang);
    i18n.changeLanguage(lang);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box className={classes.Box}>
      <LanguageIcon onClick={handleOpen} style={{ cursor: 'pointer' }} />
      <FormControl>
        <Select
          IconComponent={() => <KeyboardArrowDownIcon sx={{ color: { LYNKED_WHITE } }} />}
          onChange={handleChangeOption}
          style={{ color: 'white' }}
          value={language}
          onClose={handleClose}
          onOpen={handleOpen}
          variant="standard"
          disableUnderline
          open={open}
          classes={{
            icon: classes.selectIcon,
          }}
          MenuProps={{
            classes: {
              paper: `${classes.select} ${paperClass}`,
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            PaperProps: {
              style: {
                width: '140px',
              },
            },
            onClose: handleClose,
          }}
        >
          {Object.keys(data || {}).map((key) => (
            <MenuItem key={key} value={key}>
              {data[key].KEY_VALUE}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
